<template>
  <div class="v-innerSpinner">
    <div class="v-innerSpinner__loader">

    </div>
  </div>
</template>

<script>
export default {
  name: 'VInnerSpinner',
};
</script>

<style lang="scss" scoped>
.v-innerSpinner {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;

  &__loader {
    border: 4px solid #f3f3f3;
    border-top: 4px solid var(--color-secondary);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    animation: spin 2s linear infinite;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
